export default "/profile/images/TradeEVO.png?a2ccce6700644181542d6f4289c00b8b";